import React from "react";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { Image } from "../Image/Image";
import classNames from "classnames/bind";
import styles from "./UnavailableProducts.module.scss";
import { CartDataProductsItem } from "../../providers/cartDataStore";

const cx = classNames.bind(styles);

interface UnavailableProductProps {
  message: string;
  isUnavailable?: boolean;
  unavailableOrSoldOutProduct: CartDataProductsItem;
}

const UnavailableProductModalCard = ({
  message,
  unavailableOrSoldOutProduct,
  isUnavailable = false,
}: UnavailableProductProps) => {
  const showOriginalQuantity = unavailableOrSoldOutProduct.originalQuantity > unavailableOrSoldOutProduct.quantity;

  return (
    <IonGrid className={cx("border-b-1", isUnavailable && "opacity-60")}>
      <IonRow>
        <IonCol size={"2"}>
          <Image
            className={cx(
              "productImg",
              unavailableOrSoldOutProduct.stockQuantity !== undefined &&
                unavailableOrSoldOutProduct.stockQuantity < 1 &&
                "opacity-60"
            )}
          />
        </IonCol>
        <IonCol>
          <IonRow className="p-1.5">
            <IonCol className="ion-no-padding ion-text-left">{unavailableOrSoldOutProduct.name}</IonCol>
          </IonRow>
          <IonRow className="flex items-center gap-2 p-1.5">
            <IonCol size="auto" className="ion-no-padding ion-text-left">
              {message}
            </IonCol>
            {(showOriginalQuantity || isUnavailable) && (
              <div className="line-through font-bold text-[--ion-color-danger-shade]">
                {unavailableOrSoldOutProduct.originalQuantity}
              </div>
            )}
          </IonRow>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default UnavailableProductModalCard;
